import type { Dict } from './en';

export const fr: Dict = {
  tagline: 'Planifiez votre sport selon le ciel',
  tabs: { today: 'Aujourd’hui', week: 'Semaine', planner: 'Planificateur', settings: 'Réglages' },

  common: {
    close: 'Fermer',
    cancel: 'Annuler',
    remove: 'Retirer',
    noData: 'pas de données',
    loading: 'Chargement des prévisions en direct…',
    updated: 'mise à jour',
    liveForecast: 'Prévisions en direct',
    cachedForecast: 'Prévisions enregistrées',
    fetching: 'Chargement des prévisions pour',
    loadErr: 'Impossible de charger les prévisions :',
    checkConn: 'Vérifiez votre connexion et rechargez.',
    staleBanner: 'Hors ligne, prévisions enregistrées à',
    staleBanner2: 'Elles peuvent être périmées.',
    today: 'Auj.',
    risk: 'Risque',
  },

  risk: {
    g: 'C’est bon',
    y: 'Un peu risqué, vérifiez les détails',
    r: 'Risque élevé',
    gShort: 'C’est bon',
    yShort: 'Un peu risqué',
    rShort: 'Risque élevé',
    // one-word verdicts for the narrow block chips
    gTiny: 'Allez-y',
    yTiny: 'Risqué',
    rTiny: 'Évitez',
  },

  home: {
    hi: 'max',
    lo: 'min',
    verdictSub: 'Meilleure fenêtre {range} · risque {score}',
    verdictBadSub: 'Explorez l’onglet Semaine pour une meilleure fenêtre.',
    verdictDoneSub: 'Demain est déjà noté dans l’onglet Semaine.',
    todayBlocks: 'Les blocs du jour',
    blockByBlock: 'Le jour, bloc par bloc',
    snowTitle: '{cm} de neige fraîche en route',
    snowBody: 'Au cours des prochaines 48 h, {activities} sera superbe.',
    viewWeek: 'Voir la semaine',
    plan: 'Planifier',
    sunrise: 'Lever',
    sunset: 'Coucher',
    radar: 'Radar',
    cams: 'Caméras',
    camsSub: 'Vues en direct',
    feelsLike: 'Ressenti {t}',
    storyDry: 'Sec toute la journée.',
    storyStart: '{kind} vers {time}.',
    storyEnd: '{kind} jusque vers {time}.',
    kindRain: 'Pluie',
    kindSnow: 'Neige',
    bestLine: 'Meilleure fenêtre {range} · risque {score}.',
    bestLineNone: 'Plus de bonne fenêtre aujourd’hui.',
    next24: 'Prochaines 24 heures',
    bestTitle: 'Meilleure fenêtre',
    bestNow: 'Allez-y, bon jusqu’à {end}',
    bestAt: 'Allez-y à {range}',
    bestNone: 'Plus de bonne fenêtre aujourd’hui. La semaine ci-dessous en offre de meilleures.',
    next7: 'Prochains 7 jours',
    next7Fine: 'min → max, échelle commune · point = maintenant',
    // captions for the other daily metrics; {u} is the display unit
    next7FineWind: 'soutenu → rafales, {u} · échelle commune',
    next7FineRain: 'probabilité de précipitations · total en {u}',
    next7FineSnow: 'neige totale, {u} · échelle commune',
    metricTemp: 'Température',
    show14: 'Voir 14 jours',
    show7: 'Voir 7 jours',
    dayBest: 'meilleur bloc risque {score}',
    nowcastRainStart: 'Pluie débutant vers {time}',
    nowcastSnowStart: 'Neige débutant vers {time}',
    nowcastRainEnd: 'Pluie en cours, fin vers {time}',
    nowcastSnowEnd: 'Neige en cours, fin vers {time}',
    nowcastRainOn: 'Pluie pour les prochaines heures',
    nowcastSnowOn: 'Neige pour les prochaines heures',
    nowcastRainTotal: '≈ {amt} au cours des 3 prochaines h',
    nowcastSnowTotal: '≈ {amt} de neige au cours des 3 prochaines h',
    radarWet: 'Précipitations proches',
    radarDry: 'Rien à proximité',
    tileUv: 'Indice UV',
    tileWind: 'Vent',
    tileHumidity: 'Humidité',
    tileSun: 'Clarté',
    uv0: 'Faible',
    uv1: 'Modéré',
    uv2: 'Élevé',
    uv3: 'Très élevé',
    uv4: 'Extrême',
    uvAdvice: 'Protection jusqu’à {time}',
    uvNone: 'Aucune protection requise',
    gustsTo: 'Rafales à {v} vers {time}',
    calmDay: 'Calme pour le reste de la journée',
    dew0: 'Air sec',
    dew1: 'Confortable',
    dew2: 'Humide',
    dew3: 'Lourd',
    dewPoint: 'Point de rosée {t}',
    daylightLeft: '{h} h de clarté restante',
    tileAqhi: 'Qualité de l’air',
    aqhi0: 'Risque faible',
    aqhi1: 'Risque modéré',
    aqhi2: 'Risque élevé',
    aqhi3: 'Risque très élevé',
    aqhiSub0: 'CAS : air idéal pour être dehors',
    aqhiSub1: 'CAS : groupes sensibles, allez-y doucement',
    aqhiSub2: 'CAS : réduisez l’effort à l’extérieur',
    aqhiSub3: 'CAS : évitez l’effort à l’extérieur',
    aqi0: 'Bon',
    aqi1: 'Modéré',
    aqi2: 'Malsain pour les groupes sensibles',
    aqi3: 'Malsain',
    aqi4: 'Très malsain',
    aqi5: 'Dangereux',
    aqiSub0: 'IQA : air idéal pour être dehors',
    aqiSub1: 'IQA : groupes sensibles, allez-y doucement',
    aqiSub2: 'IQA : réduisez l’effort à l’extérieur',
    aqiSub3: 'IQA : évitez l’effort à l’extérieur',
    alertUntil: 'jusqu’à {time}',
  },

  radar: {
    title: 'Radar et prochaines heures',
    modeRadar: 'Radar',
    modeRain: 'Pluie',
    modeWind: 'Vent',
    modeWaves: 'Vagues',
    hintRadar:
      'Radar observé pour la dernière heure, la projection officielle d’ECCC pour la prochaine, puis pluie du modèle HRDPS (marquée ≈) jusqu’à 6 heures. Couvre le Canada et les États-Unis.',
    hintRadarGlobal:
      'Précipitations pour la dernière heure et les 4 prochaines, une prévision continue par Rainbow AI. Lancez la lecture ou parcourez la ligne du temps en bas.',
    hintRain:
      'Animation de pluie prévue pour les prochaines heures. Lancez la lecture ou parcourez la ligne du temps en bas.',
    hintWind:
      'Vitesse et direction du vent pour les prochaines heures. Même ligne du temps, animée en flux.',
    hintWaves:
      'Hauteur et direction de la houle pour les prochaines heures, la vue du surfeur et du marin. Eaux libres seulement.',
    now: 'maintenant',
    play: 'Lecture',
    pause: 'Pause',
    hybridLoading: 'Chargement du radar…',
    hybridErr: 'Le radar est indisponible pour le moment. Essayez la vue Pluie.',
    noCoverage: 'Le radar n’est pas encore offert pour cette région. Utilisez la vue Pluie.',
    frames: 'Chargement des images… {done}/{total}',
  },

  cams: {
    title: 'Caméras à proximité',
    loading: 'Recherche de caméras…',
    none: 'Aucune webcam à moins de 60 km de cet endroit.',
    unavailable: 'Les webcams sont indisponibles pour le moment.',
    live: 'EN DIRECT',
    viewOnWindy: 'Voir sur Windy.com',
    credit: 'Webcams par',
  },

  controls: {
    activity: 'Activité',
    chooseAct: 'Choisissez votre activité',
    blockLen: 'Durée du bloc',
    riskTol: 'Tolérance au risque',
    hours: 'Heures affichées',
    cautious: 'Prudent',
    balanced: 'Équilibré',
    tolerant: 'Tolérant',
    tune: 'Ajuster les critères',
    hourUnit: 'h',
    offSeason: 'hors saison',
    addAct: 'Ajouter une activité',
  },

  add: {
    title: 'Nouvelle activité',
    name: 'Nom',
    namePh: 'p. ex. Kayak',
    emoji: 'Émoji',
    cat: 'Catégorie',
    newCat: '+ Nouvelle catégorie…',
    newCatPh: 'Nom de la catégorie',
    season: 'Saison',
    seasonWarm: 'Saison chaude',
    seasonWinter: 'Hiver',
    seasonAll: 'Toute l’année',
    create: 'Ajouter et ajuster les critères',
    remove: 'Supprimer cette activité',
  },

  tune: {
    critFor: 'Critères pour',
    hint: 'Quelle importance donner à chaque facteur? 0 = ignorer, 10 = critique. Les préréglages remplissent ces valeurs; ajustez-les à votre goût. Le vent et la houle prennent aussi une plage idéale : sous le min, c’est risqué aussi (le surf veut des vagues, la voile veut du vent).',
    ideal: 'idéal',
    min: 'min',
    max: 'max',
    rain: 'Pluie',
    rainS: 'Probabilité et quantité de précipitations',
    snow: 'Base de neige',
    snowS: 'Risque quand la neige au sol est trop mince',
    fresh: 'Neige fraîche',
    freshS: 'Recherche la poudreuse des dernières 48 h',
    wind: 'Vent',
    windS: 'Vent soutenu et rafales',
    cold: 'Froid',
    coldS: 'Trop froid sous',
    heat: 'Chaleur',
    heatS: 'Trop chaud au-dessus de',
    uv: 'UV',
    uvS: 'Indice d’exposition au soleil',
    swell: 'Houle',
    swellS: 'Hauteur de la houle océanique',
    tide: 'Marée',
    tideS: 'Risque quand la marée est haute',
    reset: 'Revenir aux valeurs du préréglage',
  },

  board: {
    weekGlance: '· votre semaine en un coup d’œil',
    weekGlanceSolo: 'Votre semaine en un coup d’œil',
    legendG: 'C’est bon',
    legendY: 'Un peu risqué',
    legendR: 'Risque élevé',
    emptyTitle: 'Pas encore de prévisions',
    nextWeek: '+ Semaine suivante',
    backWeek: '− Une semaine',
    lowConf: 'jours 8–14 : tendance à plus long terme, fiabilité moindre',
  },

  detail: {
    title: 'Détail du bloc',
    empty: 'Touchez un bloc dans la grille pour l’inspecter et l’ajouter à votre planificateur.',
    addPlanner: 'Ajouter à mon planificateur',
    inPlanner: 'Au planificateur',
    rain: 'Pluie',
    snow: 'Neige',
    freshSnow: 'Fraîche',
    wind: 'Vent',
    feels: 'Ressenti',
    uv: 'UV',
    swell: 'Houle',
    tide: 'Marée',
    tideLow: 'basse',
    tideMid: 'mi-marée',
    tideHigh: 'haute',
    uvIdx: 'indice',
    base: 'au sol',
    fresh48h: 'fraîche/48 h',
    gusts: 'rafales',
    chance: 'prob.',
    felt: 'ressenti',
    air: 'température',
    min: 'min',
    max: 'max',
    hourly: 'Heure par heure',
    tempCurve: 'Ressenti',
    rainCurve: 'Pluie',
    windCurve: 'Vent',
    mostly: 'surtout {factor}',
    scoredFor: 'Noté pour {activity} selon vos critères',
    adjust: 'Ajuster',
    share: 'Partager',
    shareText: '{activity} à {place}, {when} : {verdict}.',
    shareCopied: 'Lien copié',
  },

  planner: {
    title: 'Mon planificateur',
    empty: 'Aucune séance planifiée. Choisissez un bloc vert!',
    addCal: 'Ajouter au calendrier',
    addAllCal: 'Tout ajouter au calendrier',
    calOpenEach: 'Cliquez chaque séance pour l’ajouter',
    calBack: '← Retour',
    calGoogle: 'Google Agenda',
    calOutlook: 'Outlook.com',
    calOffice: 'Microsoft 365 (travail/école)',
    calIcs: 'Fichier calendrier (.ics)',
    calIcsHint: 'Copie unique. Elle ne se mettra pas à jour si vos plans changent.',
    notePh: 'Ajouter une note, p. ex. « Tennis avec Jean, 9–10 »',
    feedEnable: 'Synchroniser avec mon calendrier',
    feedHint:
      'L’option la plus simple : configurez une fois et chaque séance planifiée s’ajoute automatiquement à votre calendrier, mises à jour comprises.',
    feedBusy: 'Création de votre lien de calendrier…',
    feedError: 'Impossible de joindre le serveur de synchronisation. Vérifiez votre connexion et réessayez.',
    feedOn: 'Synchronisation active. Dernière étape : abonnez-vous dans votre calendrier.',
    feedAppleSteps:
      'Touchez Calendrier Apple ci-dessous, puis « S’abonner » quand Calendrier le demande. C’est tout, les nouvelles séances apparaîtront d’elles-mêmes.',
    feedApple: 'Calendrier Apple',
    feedCopy: 'Copier le lien',
    feedCopied: '✓ Copié',
    feedCopyManual: 'Sélectionnez et copiez le lien :',
    feedNote:
      'Vos changements, suppressions comprises, mettent le lien à jour en quelques secondes. Calendrier Apple le relit toutes les quelques heures; Google et Outlook le font à leur propre rythme, ce qui peut prendre des heures (parfois jusqu’à un jour), même après un réabonnement.',
    feedOff: 'Désactiver la synchronisation',
    notifyMe: 'M’alerter si les prévisions changent',
    notifyDenied: 'Les notifications sont bloquées dans les réglages de votre navigateur.',
    notifyUnsupported:
      'Les alertes push demandent l’app installée sur l’écran d’accueil (iOS) ou un navigateur compatible.',
    planned: 'planifiée',
  },

  alerts: {
    title: 'Alertes',
    empty: 'Aucune alerte. Planifiez une séance et BlockCast surveillera les prévisions pour vous.',
    improved: '{activity} {when} s’est amélioré : maintenant {band}',
    worsened: '{activity} {when} s’est dégradé : maintenant {band}',
    markRead: 'Tout marquer comme lu',
    enablePush: 'Activer les alertes push',
    pushOn: 'Alertes push actives',
    pushOff: 'Désactiver',
  },

  location: {
    set: 'Choisissez votre emplacement',
    searchPh: 'Cherchez une ville ou un endroit… p. ex. Québec, Le Valinouët, Genève',
    kinds: {
      resort: 'Station',
      ski: 'Domaine skiable',
      peak: 'Sommet',
      lake: 'Lac',
      river: 'Rivière',
      falls: 'Chute',
      beach: 'Plage',
      bay: 'Baie',
      island: 'Île',
      park: 'Parc / réserve',
      golf: 'Golf',
      marina: 'Marina',
      camp: 'Camping',
      hut: 'Refuge',
      viewpoint: 'Point de vue',
      forest: 'Forêt',
      pass: 'Col',
    },
    mapHint:
      '…ou touchez la carte pour choisir un endroit précis : un sentier, un lac, une montagne. Glissez l’épingle pour ajuster.',
    namePh: 'Nommez cet endroit',
    naming: 'Recherche du nom…',
    useSpot: 'Utiliser cet endroit',
    noMatch: 'Aucun résultat.',
    myLoc: 'Ma position',
    mapUnavail: 'Carte indisponible (Leaflet n’a pas pu charger). Utilisez la recherche ci-dessus.',
    useMyLoc: 'Utiliser ma position actuelle',
    mySpots: 'Mes endroits',
    saveSpot: 'Enregistrer',
    change: 'Changer d’emplacement…',
    following: 'Suit votre appareil',
    pinned: 'Endroit fixé',
    locating: 'Localisation…',
    denied: 'La localisation est désactivée pour BlockCast. Activez-la dans les réglages.',
    unavailable: 'Impossible d’obtenir votre position. Touchez pour réessayer.',
    lastUsed: 'Dernier endroit',
    layerSat: 'Satellite',
    layerMap: 'Carte',
  },

  settings: {
    title: 'Réglages',
    appearance: 'Apparence',
    theme: 'Thème',
    themeSystem: 'Auto',
    themeLight: 'Clair',
    themeDark: 'Sombre',
    language: 'Langue',
    unitsTitle: 'Unités',
    units: 'Mesures',
    metric: 'Métrique (°C, km/h)',
    imperial: 'Impérial (°F, mph)',
    clock: 'Horloge',
    about: 'À propos',
    aboutBody:
      'BlockCast note chaque bloc de votre semaine pour votre sport : vert = allez-y. Données en direct d’Open-Meteo; radar par ECCC SMC; webcams par Windy.com; cartes par MapLibre, Leaflet, OpenFreeMap et les contributeurs OpenStreetMap. Réglages et séances restent sur votre appareil.',
    version: 'Version',
    privacy: 'Politique de confidentialité',
    getApp: 'Obtenir l’app iPhone',
  },

  intro:
    'BlockCast note chaque bloc de votre semaine pour votre sport : vert = allez-y. Choisissez votre activité, touchez un bloc vert, planifiez votre séance.',

  activities: {
    tennis: 'Tennis',
    cycling: 'Vélo',
    jogging: 'Course',
    fishing: 'Pêche',
    golf: 'Golf',
    hiking: 'Randonnée',
    sailing: 'Voile',
    picnic: 'Pique-nique / BBQ',
    skiing: 'Ski',
    snowmob: 'Motoneige',
    motorcycle: 'Moto',
    utv: 'VTT / Côte-à-côte',
    waterski: 'Ski nautique',
    pontoon: 'Ponton',
    pickleball: 'Pickleball',
    beach: 'À la plage',
  },

  cats: {
    powersports: 'Sports motorisés',
    trail: 'Sentier & route',
    water: 'Sur l’eau',
    court: 'Terrain & parcours',
    snow: 'Neige',
    leisure: 'Détente',
  },
};
